export default "__VITE_ASSET__qZkqC6uH__"